module.exports = __webpack_public_path__ + "img/2.e269546f.jpg";